import TempElemsRenderService from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/temp-elems-render-service';
import SnapLineRenderService from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/snapline-render-service';
import RenderService, { RegionRenderConfig, RegionRenderProps } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/performance/base-region-render-service';
import GuideRenderService from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/guide-render-service';

export enum LayerType {
    TEMP,
    SNAPLINE,
    GUIDE,
}
export default class RenderServiceManager {
    static instance: RenderServiceManager;
    static getInstance(): RenderServiceManager {
        if (!this.instance) {
            this.instance = new RenderServiceManager();
        }
        return this.instance;
    }

    public renderServiceList: Map<LayerType, RenderService>;

    public constructor() {
        this.renderServiceList = new Map();
    }

    public initLayer(props: RegionRenderProps, type: LayerType): void {
        if (!this.renderServiceList.get(type)) {
            if (type === LayerType.TEMP) {
                this.renderServiceList.set(type, new TempElemsRenderService(props));
            }
            if (type === LayerType.SNAPLINE) {
                this.renderServiceList.set(type, new SnapLineRenderService(props));
            }
            if (type === LayerType.GUIDE) {
                this.renderServiceList.set(type, new GuideRenderService(props));
            }
        }
    }

    public dispose(): void {
        this.renderServiceList.forEach((service) => {
            service.dispose();
        });
    }

    public updateWithData(config: RegionRenderConfig): void {
        this.renderServiceList.forEach((service) => {
            service.updateWithData(config);
        });
    }

    public updatePosition = (renderRectConfig?): void => {
        this.renderServiceList.forEach((service) => {
            service?.updatePosition(renderRectConfig);
        });
    };
}
